import http from '@/core/http';
import * as Types from './types';
/**
 * 分页查询
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1268
 */
export const userFindPage = (params: Types.IUserFindPageReq, loading: boolean = true) => {
  const url = '/uacs/managed/web/user/findPage';
  return http.post<Types.IUserFindPageRes>({
    url,
    data: params,
    loading,
  });
};

/**
 * 保存用户角色
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1269
 */
export const userSaveUserRole = (params: Types.IUserSaveUserRoleReq) => {
  const url = '/uacs/managed/web/user/saveUserRole';
  return http.post({
    url,
    data: params,
    loading: true
  });
};

/**
 * 启用
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1368
 */
export const userEnable = (params: { id: string; }) => {
  const url = '/uacs/managed/web/user/enable';
  return http.post({
    url,
    params,
    loading: true
  });
};

/**
 * 停用
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1369
 */
export const userDisable = (params: { id: string; }) => {
  const url = '/uacs/managed/web/user/disable';
  return http.post({
    url,
    params,
    loading: true
  });
};

/**
 * 创建用户
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1382
 */
export const userCreate = (params: Types.IUserCreateReq) => {
  const url = '/uacs/managed/web/user/create';
  return http.post({
    url,
    data: params,
    loading: true
  });
};

/**
 * 更新用户
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1367
 */
export const userUpdate = (params: Types.IUserUpdateReq) => {
  const url = '/uacs/managed/web/user/update';
  return http.post({
    url,
    data: params,
    loading: true
  });
};

/**
 * 获取当前用户基本信息
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1449
 */
export const userMe = () => {
  const url = '/uacs/api/user/me';
  return http.get<Types.IUserMeRes>({
    url,
    loading: true
  });
};

/**
 * 获取当前用户菜单树
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1450
 */
export const userFindMenuTree = (params: string[]) => {
  const url = '/uacs/api/user/findMenuTree';
  return http.post<Types.IUserFindMenuTreeRes>({
    url,
    data: params,
    loading: true
  });
};

/**
 * 修改密码
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1490
 */
export const userChangePassword = (params: Types.IUserChangePasswordReq) => {
  const url = '/uacs/api/user/changePassword';
  return http.post({
    url,
    data: params,
    loading: true
  });
};

/**
 * 获取当前用户租户列表
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/1471
 */
export const userFindTenants = () => {
  const url = '/uacs/api/user/findTenants';
  return http.get<Types.IUserFindTenantsRes>({
    url,
    loading: true
  });
};

/**
 * 修改用户标签
 */
export const saveUserTag = (params: Types.ISaveUserTagReq) => {
  const url = '/uacs/managed/web/user/saveUserTag';
  return http.post({
    url,
    loading: true,
    data: params,
  });
};

/**
 * 从组织中移除用户
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/3465
 */
export const userRemoveUserFromOrganization = (params: Types.IUserRemoveUserFromOrgReq) => {
  const url = '/uacs/managed/web/user/removeUserFromOrganization';
  return http.post({
    url,
    data: params,
    loading: true
  });
};

/**
 * 添加用户到组织下
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/3464
 */
export const userAddUserToOrganization = (params: Types.IUserAddUserToOrgReq) => {
  const url = '/uacs/managed/web/user/addUserToOrganization';
  return http.post<Types.IUserAddUserToOrgRes>({
    url,
    data: params,
    loading: true,
    showErrorMessage: false,
  });
};

/**
 * 查询可授权的角色
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/3522
 */
export const userFindGrantableRolesById = (params: { id: string; }) => {
  const url = '/uacs/managed/web/user/findGrantableRolesById';
  return http.get<Types.IUserFindGrantableRolesByIdRes>({
    url,
    params,
    loading: true
  });
};

/**
 * 查询用户组织变更历史
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/4766
 */
export const userFindOrganizationChangeHistories = (params: { id: string; }) => {
  const url = '/uacs/managed/web/user/findOrganizationChangeHistories';
  return http.get<Types.IUserFindOrganizationChangeHistoriesRes>({
    url,
    params,
    loading: true
  });
};

/**
 * 获取用户可以访问的客户端列表
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/5214
 */
export const userAccessibleClients = (params: Types.IUserAccessibleClientsReq) => {
  const url = '/uacs/managed/web/user/accessibleClients';
  return http.get<Types.IUserAccessibleClientsRes>({
    url,
    params,
    loading: true
  });
};

/**
 * 获取用户菜单树
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/5218
 */
export const userWebFindMenuTree = (params:Types.IWebUserFindMenuTreeReq) => {
  const url = '/uacs/managed/web/user/findMenuTree';
  return http.post<Types.IWebUserFindMenuTreeRes>({
    url,
    params,
    loading: true
  });
};

/**
 * 获取用户功能权限列表
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/5234
 */
export const userFindPermissions = (params: Types.IUserFindPermissionsReq) => {
  const url = '/uacs/managed/web/user/findPermissions';
  return http.get<Types.IUserFindPermissionsRes>({
    url,
    params,
    loading: true
  });
};

/**
 * 根据ID查询
 * @see yapi地址：https://yapi.tiangong.site/project/26/interface/api/5342
 */
export const userFindById = (params: { id: string; }) => {
  const url = '/uacs/managed/web/user/findById';
  return http.get<Types.IUserFindPageResListItem>({
    url,
    params,
    loading: true
  });
};

/**
 * 保存用户客户端
 * @see https://app.apifox.com/link/project/6658774/apis/api-381547463
 */
export const saveUserClient = (params: Types.SaveUserClientReq) => {
  const url = '/uacs/managed/web/user/saveUserClient';
  return http.post({
    url,
    data: params,
    loading: true
  });
};
